module.exports = __webpack_public_path__ + "cross.7e67061256991d486933cfa9e5b3cbd1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cross.svg
// module id = 381
// module chunks = 0